import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getToken } from '../../utils/auth';

function PaymentGateway() {
    const navigate = useNavigate();
    const { id } = useParams(); // Extract `id` from the URL
    const [paymentDetails, setPaymentDetails] = useState({});

    // Extract price from the query string
    const queryParams = new URLSearchParams(window.location.search);
    const price = queryParams.get('price') || '0.00'; // Default to '0.00' if price is not found

    useEffect(() => {
        // Simulate fetching payment details using the id and price from the URL
        setPaymentDetails({
            id: id || 'N/A',
            amount: price,
            date: new Date().toLocaleString(),
        });
    }, [id, price]);

    const initiatePayment = async () => {
        if (!id || !price) {
            toast.info('Invalid payment details. Please try again.');
            return;
        }

        try {
            const payload = {
                amount: price,
                currency: 'USD',
                paymentFor: 'identifier-reservation',
                identifierId: id,
            };

            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/payment/initiate-payment`,
                payload,
                {
                    headers: {
                        accept: '*/*',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const paymentUrl = response.data.url; // Extract the URL from the API response
            if (paymentUrl) {
                window.location.href = paymentUrl; // Navigate to the payment page
            } else {
                toast.error('Failed to retrieve payment URL.');
            }
        } catch (error) {
            console.error('Error initiating payment:', error);
            toast.error(
                error?.response?.data?.message ||
                'Failed to initiate payment. Please try again.'
            );
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Payment Gateway</h1>
            <p style={styles.details}><strong>Transaction ID:</strong> {paymentDetails.id}</p>
            <p style={styles.details}><strong>Amount:</strong> $ {paymentDetails.amount}</p>

            <button style={styles.button} onClick={initiatePayment}>
                Proceed to Pay
            </button>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        textAlign: 'center',
    },
    heading: {
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '20px',
    },
    details: {
        fontSize: '18px',
        color: '#555',
        textAlign: 'center',
        marginBottom: '10px',
    },
    button: {
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px',
    },
};

export default PaymentGateway;
